__webpack_require__.p = "https://contract.ma.globalsellingcommunity.cn/";